var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { TabCordionCore } from '@core-front/tab-cordion';
import { Accordion, AccordionContent, AccordionHeader, AccordionItem, AccordionTitle, AccordionItemCoreContext, } from '@telia-front/accordion';
import Badge from '@telia-front/badge';
import Grid, { GridColumn } from '@telia-front/grid';
import Tabs, { TabsItem } from '@telia-front/tabs';
export default class TabCordion extends React.Component {
    constructor() {
        super(...arguments);
        this.renderAccordionItem = (props) => {
            const getType = (isOpen) => {
                if (props.type === 'employee') {
                    return isOpen ? 'employee-active' : 'employee';
                }
                return isOpen ? 'primary' : 'inactive';
            };
            return (React.createElement(AccordionItem, { className: props.className, type: props.type === 'employee' ? 'employee' : undefined, icon: props.icon || props.image, id: props.id },
                React.createElement(AccordionHeader, null, props.tagContent ? (React.createElement(AccordionItemCoreContext.Consumer, null, context => (React.createElement(AccordionTitle, { className: "h4" },
                    React.createElement(Grid, { gutter: "xsmall", align: ['middle-xs'], noWrap: true },
                        React.createElement(GridColumn, { width: ['min'] }, props.label),
                        React.createElement(GridColumn, { width: ['max'] }, props.tagContent && (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: "sr-only" }, "("),
                            React.createElement(Badge, { size: "medium", text: props.tagContent, purpose: getType(context.isOpen) }),
                            React.createElement("span", { className: "sr-only" }, ")"))))))))) : (React.createElement(AccordionTitle, { className: "h4" }, props.label))),
                React.createElement(AccordionContent, null, props.children)));
        };
        // Accordion and tabs need to be passed as named functions. Passing components as arrow functions
        // causes them to be remounted when certain props change and that broke accordion scrolling.
        // https://medium.com/@deadalley31/the-impact-of-passing-components-as-props-with-arrow-functions-in-react-6993ff0606f9
        this.accordionComponent = (props) => {
            return React.createElement(Accordion, Object.assign({}, props, { theme: this.props.theme, fullWidth: this.props.fullWidth }));
        };
        this.tabsComponent = (props) => {
            return React.createElement(Tabs, Object.assign({}, props, { theme: this.props.theme }));
        };
    }
    BEM() {
        const classArray = [];
        if (this.props.background) {
            classArray.push('tab-cordion--background-' + this.props.background);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        const _a = this.props, { theme } = _a, rest = __rest(_a, ["theme"]);
        return (React.createElement(TabCordionCore, Object.assign({}, rest, { className: this.BEM(), components: {
                Accordion: this.accordionComponent,
                AccordionContent,
                AccordionHeader,
                AccordionItem,
                AccordionTitle,
                Tabs: this.tabsComponent,
                TabsItem,
            }, accordionItemRenderer: this.renderAccordionItem })));
    }
}
